module.exports = __webpack_public_path__ + "img/IMG_0459_L.943a4e32.webp";